export default "__VITE_ASSET__647b4091__"